module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.8eed8842.svg";